import { Results } from '../../models/unit.model';
import { ElementKind } from '../../models/project.model';
import { IElementCategoryMapResultsContext } from '../../models/element-categories.model';
import { requiredKind } from '../element-kind.helpers';
import { getElementCategory } from '../element-category.helpers';

/**
 * Allow element categories to adjust the results before they are summed up,
 * applying each owning ancestor's `mapResults` from the leaf upwards (e.g. AHU /
 * Heating moving A-stage energy into B6).
 */
export const mapResultsByElementCategories = (
  results: Results,
  context: Omit<IElementCategoryMapResultsContext, 'categoryElement'>,
): Results => {
  // Map results from bottom to top
  return context.path.toReversed().reduce((acc, el) => {
    const mapFn = getElementCategory(el)?.mapResults;
    return mapFn
      ? mapFn(acc, {
          ...context,
          categoryElement: requiredKind(el, ElementKind.Element),
        })
      : acc;
  }, results);
};
